import React, { FC } from 'react';

import ArenaSegmentProvider from './components/context';
import ArenaSegmentPageBody from './body';

const CsToolArenaSegmentScreen: FC = () => {
  return (
    <ArenaSegmentProvider>
      <ArenaSegmentPageBody />
    </ArenaSegmentProvider>
  );
};

export default CsToolArenaSegmentScreen;
